export default __webpack_public_path__ + "static/media/bg1.a2b3eaf0.svg";